import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * Выбирает необходимое склонение существительного в замисимости от количества единиц
 * @param {array} nounArray массив из 3х возможных склонений слова (напр. ['устройство', 'устройства', 'устройств'])
 * @param {number} number количество единиц
 * @returns {string} необходимое склонение
 */
export var determineDeclension = function determineDeclension(nounArray, number) {
  var num = Math.floor(number);
  var cases = [2, 0, 1, 1, 1, 2];
  var index = num % 100 > 4 && num % 100 < 20 ? 2 : cases[num % 10 < 5 ? num % 10 : 5];
  return nounArray[index];
};

/**
 * Форматирует строку в представление номера телефона
 * @param {string} phone номер телефона
 * @returns {string} отформатированное значение
 */
export var formatPhone = function formatPhone() {
  var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return phone.replace(/^(\d{3})(\d{3})(\d{2})(\d{2})/, '+7 $1 $2-$3-$4');
};

/**
 * Форматирует число или число в строковом формате в строку с валютой
 * @param {number | string | undefined} value значение
 * @returns {string} отформатированное значение
 */
export var getLocalCurrencyStr = function getLocalCurrencyStr(value) {
  var isNumber = typeof value === 'number' && (value || value === 0);
  var isNumberString = typeof value === 'string' && value.trim() && !Number.isNaN(Number(value));
  if (!(isNumber || isNumberString)) {
    return '';
  }
  var num = typeof value === 'string' ? Number(value) : value;
  var _num$toString$split = num.toString().split('.'),
    _num$toString$split2 = _slicedToArray(_num$toString$split, 2),
    decimal = _num$toString$split2[1];
  var withCurrency = "".concat(num).concat(decimal && decimal.length === 1 ? 0 : '', " \u20BD");
  var separator = ' ';
  return withCurrency.replace(/(\d{1,3}(?=(?:\d{3})+(?!\d)))/g, "$1".concat(separator)).replace('.', ',');
};